import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GeneralContext } from '../../shared/contexts/GeneralContext.context';

const CALLBACK_GUARD_KEY = 'loginCallbackHandledAt';
const CALLBACK_GUARD_WINDOW_MS = 15000;

const LoginCallback = () => {
  const { loginAmos, isLogged, clearAmosToken } = useContext(GeneralContext);
  const navigate = useNavigate();

  useEffect(() => {
    const now = Date.now();
    const lastHandledAt = Number(sessionStorage.getItem(CALLBACK_GUARD_KEY));
    const alreadyHandledRecently =
      Number.isFinite(lastHandledAt) &&
      now - lastHandledAt < CALLBACK_GUARD_WINDOW_MS;

    if (!alreadyHandledRecently) {
      sessionStorage.setItem(CALLBACK_GUARD_KEY, String(now));
    }

    const userEmail = localStorage.getItem('userData');
    if (userEmail?.length > 0) {
      localStorage.removeItem('userData');
    }

    if (isLogged && !alreadyHandledRecently) {
      clearAmosToken();
      loginAmos();
    }

    const oldPath = localStorage.getItem('oldPath');
    if (oldPath?.length > 0) {
      navigate(oldPath);
      localStorage.removeItem('oldPath');
    } else {
      navigate('/');
    }
  }, [clearAmosToken, navigate, isLogged, loginAmos]);

  return <></>;
};

export default LoginCallback;
